export default __webpack_public_path__ + "static/media/users.268cba98.svg";